import type { ApolloError } from '@apollo/client';
/**
 * Since in some cases the specific error is not present in StatusCode but somewhere in Status.Detail string,
 * therefore we need to check both places.
 * Need to define proper error contract at backend, tracking it here - https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/233137
 */
export function checkGraphQLErrorStatusCode(error: ApolloError, statusCode: string): boolean {
    return error.graphQLErrors?.some(e => {
        const errorStatusCode = e.extensions?.data?.['RpcException.StatusCode'];
        const errorStatusDetail = e.extensions?.data?.['RpcException.Status.Detail'];
        return statusCode === errorStatusCode || errorStatusDetail.indexOf(statusCode) !== -1;
    });
}
